var setScrollParam = function setScrollParam(_ref) {
  var axis = _ref.axis,
    parent = _ref.parent,
    distance = _ref.distance;
  if (!parent && typeof document === "undefined") {
    return;
  }
  var method = axis === "y" ? "scrollTop" : "scrollLeft";
  if (parent) {
    parent[method] = distance;
  } else {
    var _document = document,
      body = _document.body,
      documentElement = _document.documentElement;
    body[method] = distance;
    documentElement[method] = distance;
  }
};
export { setScrollParam };